import {Column, Row, RowLR, Select, Spinner, Text} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {ControlInput} from "../../../@Shared/ControlInput.js";
import {colors} from "../../../../Utils/UI/GlobalStyles.js";
import {EngineConfigPanels_SharedProps, ExtendEngineConfigPanelSharedProps} from "../ConfigPanel_Local.js";
import React from "react";
import {observer_mgl} from "mobx-graphlink";
import {FieldLabel} from "../../../@Shared/FieldLabel.js";
import {CheckBox} from "react-vcomponents";
import {GetEntries} from "js-vextensions";
import {Phase} from "../../../../Server/DB/@Shared/Phase.js";
import {EffectPointerInput} from "../../../@Shared/EffectPointerInput.js";
import {InfoButton} from "web-vcore";

const GetSharedProps = (props: EngineConfigPanels_SharedProps)=>ExtendEngineConfigPanelSharedProps(props, c=>c.phases, (c, v)=>c.phases = v);

const splitAt = 200;

export const Phases_ConfigUI = observer_mgl((props: {remote?: boolean} & EngineConfigPanels_SharedProps)=>{
	const {client, enabled} = props;
	const sharedProps = GetSharedProps(props);
	const {config, ChangeConfig} = sharedProps;
	const fp = (fieldName: keyof typeof config)=>`phases.${fieldName}`;

	return (
		<Column mt={15} style={{background: "hsla(0,0%,100%,.1)", borderRadius: 5, padding: 5, color: colors.nightTint}}>
			<Row style={{fontSize: 18}}>
				<CheckBox text="Phases" enabled={enabled} value={config.enabled} onChange={val=>ChangeConfig(c=>c.enabled = val)}/>
			</Row>

			{config.enabled &&
			<>
				<Row mt={5}>Triggers to force-set the current phase:</Row>
				<Column ml={10}>
					<RowLR mt={5} splitAt={splitAt - 10}>
						<FieldLabel text="Tech:" fieldPath={fp("goPhaseTech_triggerSet")}/>
						<ControlInput enabled={enabled} value={config.goPhaseTech_triggerSet} onChange={val=>ChangeConfig(c=>c.goPhaseTech_triggerSet = val)}/>
					</RowLR>
					<RowLR mt={5} splitAt={splitAt - 10}>
						<FieldLabel text="Drifting:" fieldPath={fp("goPhaseDrifting_triggerSet")}/>
						<ControlInput enabled={enabled} value={config.goPhaseDrifting_triggerSet} onChange={val=>ChangeConfig(c=>c.goPhaseDrifting_triggerSet = val)}/>
					</RowLR>
					<RowLR mt={5} splitAt={splitAt - 10}>
						<FieldLabel text="Dreaming:" fieldPath={fp("goPhaseDreaming_triggerSet")}/>
						<ControlInput enabled={enabled} value={config.goPhaseDreaming_triggerSet} onChange={val=>ChangeConfig(c=>c.goPhaseDreaming_triggerSet = val)}/>
					</RowLR>
					<RowLR mt={5} splitAt={splitAt - 10}>
						<FieldLabel text={`Solving (${config.goPhaseSolving_duration ?? "?"}m):`} fieldPath={fp("goPhaseSolving_triggerSet")}/>
						<ControlInput enabled={enabled} value={config.goPhaseSolving_triggerSet} onChange={val=>ChangeConfig(c=>c.goPhaseSolving_triggerSet = val)}/>
					</RowLR>
					<RowLR mt={5} splitAt={splitAt - 10}>
						<FieldLabel text="Solving, duration (for trigger above):" fieldPath={fp("goPhaseSolving_duration")}/>
						<Spinner enabled={enabled} value={config.goPhaseSolving_duration} onChange={val=>ChangeConfig(c=>c.goPhaseSolving_duration = val)}/>
						<Text>m</Text>
					</RowLR>
					<RowLR mt={5} splitAt={splitAt - 10}>
						<FieldLabel text="Delving:" fieldPath={fp("goPhaseDelving_triggerSet")}/>
						<ControlInput enabled={enabled} value={config.goPhaseDelving_triggerSet} onChange={val=>ChangeConfig(c=>c.goPhaseDelving_triggerSet = val)}/>
					</RowLR>
				</Column>
				<Row mt={5}>
					<CheckBox text="Stop enter-effects when phase is left" value={config.stopEnterEffectsWhenPhaseIsLeft} onChange={val=>ChangeConfig(c=>c.stopEnterEffectsWhenPhaseIsLeft = val)} enabled={enabled}/>
					<InfoButton ml={5} text="If enabled, then when the current phase is changed, any enter-effect that was playing for the previous phase will be stopped."/>
				</Row>

				<Row mt={15} style={{fontSize: 18}}>Phase: Initial delay</Row>
				<RowLR mt={5} splitAt={splitAt}>
					<FieldLabel text="Phase after initial-delay:" fieldPath={fp("phaseAfterInitialDelay")}/>
					<Select enabled={enabled} options={GetEntries(Phase, "ui")} value={config.phaseAfterInitialDelay} onChange={val=>ChangeConfig(c=>c.phaseAfterInitialDelay = val)}/>
				</RowLR>

				<Row mt={15} style={{fontSize: 18}}>Phase: Tech</Row>
				<RowLR mt={5} splitAt={splitAt}>
					<FieldLabel text="Enter effect:" fieldPath={fp("tech_enterEffect")}/>
					<EffectPointerInput enabled={enabled} value={config.tech_enterEffect} onChange={val=>ChangeConfig(c=>c.tech_enterEffect = val)}/>
				</RowLR>
				<RowLR mt={5} splitAt={splitAt}>
					<FieldLabel text="Expire after:" fieldPath={fp("tech_expire_after")}/>
					<Spinner enabled={enabled} value={config.tech_expire_after} onChange={val=>ChangeConfig(c=>c.tech_expire_after = val)}/>
					<Text>m, </Text>
					<FieldLabel text="to phase:" fieldPath={fp("tech_expire_toPhase")}/>
					<Select enabled={enabled} options={GetEntries(Phase, "ui")} value={config.tech_expire_toPhase} onChange={val=>ChangeConfig(c=>c.tech_expire_toPhase = val)}/>
				</RowLR>

				<Row mt={15} style={{fontSize: 18}}>Phase: Delving</Row>
				<RowLR mt={5} splitAt={splitAt}>
					<FieldLabel text="Enter effect:" fieldPath={fp("delving_enterEffect")}/>
					<EffectPointerInput enabled={enabled} value={config.delving_enterEffect} onChange={val=>ChangeConfig(c=>c.delving_enterEffect = val)}/>
				</RowLR>
			</>}
		</Column>
	);
});